<template>
        <div>
          <div>
            <label class="label-search">Coordenador:</label>
            <autocomplete-z ref="responsavelTypeahead"
                    placeholder="Digite o nome do Responsável"
                    iconClass="fas fa-users"
                    :serializer="(coordenadorId) => coordenadorId.codigo + ' - ' + coordenadorId.nome"
                    :debounceLength="3"
                    :formField="form.coordenadorId"
                    v-on:search="CoordenadorfilterName"
                    v-on:changeCode="GetCoordenadorByCode" />
          </div>
            <div class="conteiner">
                <button @click="voltar" class="button-reprova">VOLTAR</button>
                <button @click="enviar" :disabled="this.form.coordenadorId.value == null ? true : false" class="button-save">ENVIAR</button>
            </div>
        </div>
</template>

<script>
import addCoordinator from './addCoordinator'
export default addCoordinator
</script>

<style scoped>
#main{
    height: 100%;
}
.conteiner{
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}
.button-reprova {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}

  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
  .title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value {
  width: 100%;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  background-color: white;
  border-radius: 0px 0px 8px 8px;
}
.employee-value {
  width: 100%;
  display: flex;
  padding: 1rem;
  font-size: 14px;
  background-color: white;
  flex-direction: column;
  font-family: 'Segoe UI';
  gap:1rem;
  border-radius: 0px 0px 8px 8px;
}

.employee-expenses{
  display: flex;
  flex-direction: column;
}

.employee-title{
  font-weight: bold;
}

.cardtotalDespesas{
    margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/addCoordinator/addCoordinator.vue